import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { ZitadelGatewayServiceUser } from "@src/types/user-management";

export interface GetGatewayServiceUsersResult {
  success: boolean;
  data?: ZitadelGatewayServiceUser[];
  error?: string;
}

export const getGatewayServiceUsersUseCase = async (
  signal: AbortSignal,
): Promise<GetGatewayServiceUsersResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getGatewayServiceUsers(
      namespace,
      signal,
    );

    return {
      success: true,
      data: response?.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to fetch gateway service users. Please try again later.",
      ).message,
    };
  }
};
